// extracted by mini-css-extract-plugin
module.exports = {"messageText":"_b8081e4"};